import { ShowcaseItem } from '../types';

const img = (id: string) => `/images/${id}.webp`;

export const showcase: ShowcaseItem[] = [
  {
    id: 'aurora',
    title: 'Aurora — Global Brand Summit',
    category: 'Corporate',
    year: '2025',
    location: 'Dubai',
    image: img('1492684223066-81342ee5ff30'),
  },
  {
    id: 'monsoon',
    title: 'Monsoon Royale Wedding',
    category: 'Social',
    year: '2025',
    location: 'Udaipur',
    image: img('1519225421980-715cb0215aed'),
  },
  {
    id: 'volt',
    title: 'Volt — Stadium Tour',
    category: 'Entertainment',
    year: '2024',
    location: 'Bengaluru',
    image: img('1470229722913-7c0e2dbbafd3'),
  },
  {
    id: 'concord',
    title: 'Concord — Heads of State Summit',
    category: 'Political',
    year: '2024',
    location: 'Geneva',
    image: img('1505373877841-8d25f7d46678'),
  },
  {
    id: 'nova',
    title: 'Nova Cultural Biennale',
    category: 'Cultural',
    year: '2025',
    location: 'Kyoto',
    image: img('1514525253161-7a46d19cd819'),
  },
  {
    id: 'titans',
    title: 'Titans — Premier League Finals',
    category: 'Sporting',
    year: '2024',
    location: 'Mumbai',
    image: img('1540747913346-19e32dc3e97e'),
  },
];
